import React from "react";
import "./index.scss";

import { precogOversight } from "./data";
// ui
import { Row, Col, Card } from "antd";

// animations
// import { Fade } from "react-reveal";

// images
import LinkedinIcon from "../../../assets/icons/in.svg";

const { Meta } = Card;

const PrecogTeam = (props) => {
  return (
    <div ref={props.teamRef} className="precogTeam">
      <div className="precogTeamContent">
        <div className="mainText">
          <h2>Precog oversight</h2>
          <p>
            The Precog.finance team operates at the intersection of many specialized focus
            areas including distributed systems, security, cryptography and
            blockchain protocols.
          </p>
        </div>

        {/* <div className="teamList">
          <h3>Advisors</h3>

          <div className="users">
            <Row gutter={[53, 50]}>
              {precogOversight.advisors.map((item, i) => (
                <Col key={i} lg={8} xs={24}>
                  <Card
                    cover={<img alt="" src={item.avatar} />}
                    actions={[
                      <div className="viewSocial">
                        <a
                          className={`${
                            item.linkedin === null ? "disable" : ""
                          }`}
                          href={item.linkedin}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={LinkedinIcon} alt="" />
                        </a>
                      </div>,
                    ]}
                  >
                    <Meta
                      title={<h4>{item.name}</h4>}
                      description={item.title}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div> */}

        <div className="teamList">
          <h3>Leads</h3>

          <div className="users">
            <Row gutter={53}>
              {precogOversight.leads.map((item, i) => (
                <Col key={i} lg={8} xs={24}>
                  <Card
                    cover={<img alt="" src={item.avatar} />}
                    actions={[
                      <div className="viewSocial">
                        <a
                          className={`${
                            item.linkedin === null ? "disable" : ""
                          }`}
                          href={item.linkedin}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={LinkedinIcon} alt="" />
                        </a>
                      </div>,
                    ]}
                  >
                    <Meta
                      title={
                        <>
                          <h4>{item.name}</h4>
                          <h5>{item.role}</h5>
                        </>
                      }
                      description={item.title}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrecogTeam;
